import React, { useState } from 'react';
import { Page } from '../components/Page';
import { CompareCol } from '../components/CompareCol';

import { useLocation } from "react-router-dom";

function Compare(props) {
    const location = useLocation();
    console.log("Location", location);

    return (
        <Page>
            <CompareCol frat={location?.state?.frat}/>
            <CompareCol />
        </Page>
    );
}


export { Compare };